// 封装用于检查登录和解绑登录的mixin
import { checkIfBindCustomer } from "@/api/auth";
import { getCurExternalContact } from "@/utils/wxCodeAuth";
import { unbindWechatToCrmCustomer } from "@/api/auth";
import store from "@/store";

export const checkMixin = {
  data() {
    return {
      userInfo: "",
      externalUserId: "",
    };
  },
  methods: {
    // 检查绑定
    checkIsBindM() {
      return new Promise(async (resolve, reject) => {
        try {
          if (!this.userInfo) {
            console.warn("没有userInfo,进行重试");
            this.getUserInfo();
          }

          // 获取对面微信客户id route.query.redirect
          const res1 = await getCurExternalContact();
          console.log("获取的外部联系人信息：", res1);

          const res2 = await checkIfBindCustomer({
            externalUserId: res1,
            corpId: store.getters.corpId,
            tenantId: store.getters.tenantId,
          });
          console.log("检查外部联系人是否已经绑定过crm：", res2.result);

          // 1-已绑定，2-未绑定，3-待重新绑定
          console.log(this.$route);
          if (this.$route.query.redirect && res2.result === 1) {
            this.$router.push(this.$route.query.redirect);
            console.log("已完成登录校验，开始跳转重定向页面");
            return reject("执行重定向");
          }
          if (res2.result !== 1) {
            // 未绑定 /schoolUserInfo/1771027087562981378 /login/ww7ac6c380a2472a67/1000002
            console.log("未绑定", this.$route.query.redirect, this.$route.path);
            this.$router.push(
              `/bindCrmUser?redirect=${
                this.$route.query.redirect
                  ? decodeURIComponent(this.$route.query.redirect)
                  : this.$route.path
              }`
            );
            return reject("跳转绑定");
          }
          resolve();
        } catch {
          reject();
        }
      });
    },
    // 检查登录
    checkLogin() {
      console.log("检查登录", this.userInfo);
      if (!this.userInfo || "" + this.userInfo === "undefined") {
        console.log("未登录！path:", this.$route.path);
        this.$router.replace(
          `/login/${this.$route.query.corpId || store.getters.corpId}/${
            this.$route.query.agentId || store.getters.agentId
          }?redirect=${decodeURIComponent(this.$route.path)}`
        );
      }
    },
    // 解绑登录
    async unBindM() {
      if (!this.userInfo) {
        console.warn("没有userInfo,进行重试");
        this.getUserInfo();
      }
      // 获取最新外部客户id
      // if (!this.externalUserId)
      this.externalUserId = await getCurExternalContact();
      await unbindWechatToCrmCustomer({
        corpId: store.getters.corpId,
        externalUserId: this.externalUserId,
        wechatUserId: this.userInfo.userId,
        tenantId: store.getters.tenantId,
      });
      this.$alert("解绑成功");

      // 检查是否已绑定crm账号
      this.checkIsBindM();
    },
    getUserInfo() {
      // 兼容获取缓存和vuex的userInfo信息
      let userInfo = localStorage.getItem("userInfo");
      if (!userInfo || "" + userInfo === "undefined") {
        this.userInfo = store.getters.userInfo;
      } else {
        this.userInfo = JSON.parse(userInfo);
      }
      console.log("获取userInfo", this.userInfo);
    },
  },
  created() {},
};

export default {
  checkMixin,
};
